export interface ContactFormResponse {
    code: string;
    message: string;
}

export class ContactFormResponseHelper {

    static create(): ContactFormResponse {
        return {
            code: '',
            message: ''
        };
    }

    static transformFromApi(apiData: Object) {
        const contactFormResponse = ContactFormResponseHelper.create();
        contactFormResponse.code = apiData['CODIGO'];
        contactFormResponse.message = apiData['MENSAJE'];
        return contactFormResponse;
    }
}